export default __webpack_public_path__ + "static/media/misc-fireplaceA.39c2579b.jpg";